import { render, staticRenderFns } from "./CardUpdatePage.vue?vue&type=template&id=87998f26&scoped=true&"
import script from "./CardUpdatePage.vue?vue&type=script&lang=js&"
export * from "./CardUpdatePage.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdatePage.vue?vue&type=style&index=0&id=87998f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87998f26",
  null
  
)

export default component.exports